var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDoubtful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EF7F18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.57143V8C8.39556 8 8.78224 7.8827 9.11114 7.66294C9.44004 7.44318 9.69638 7.13082 9.84776 6.76537C9.99913 6.39992 10.0387 5.99778 9.96157 5.60982C9.8844 5.22186 9.69392 4.86549 9.41421 4.58579C9.13451 4.30608 8.77814 4.1156 8.39018 4.03843C8.00222 3.96126 7.60009 4.00087 7.23463 4.15224C6.86918 4.30362 6.55682 4.55996 6.33706 4.88886C6.1173 5.21776 6 5.60444 6 6",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99948 12.0001C8.47286 12.0001 8.85662 11.6163 8.85662 11.1429C8.85662 10.6695 8.47286 10.2858 7.99948 10.2858C7.52609 10.2858 7.14233 10.6695 7.14233 11.1429C7.14233 11.6163 7.52609 12.0001 7.99948 12.0001Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubtful);
export default __webpack_public_path__ + "static/media/icon-doubtful.14f344252312583e3595f29d48c013fc.svg";
export { ForwardRef as ReactComponent };